import React from 'react';
import css from './HowItWorksSteps.module.css';

/** "How it works" card (Sam mock, Oct 16): home page for guests and the talker dashboard. */
const P = { fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };
const icons = {
  chat: (
    <svg viewBox="0 0 24 24" {...P}><path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z" /><path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1" /></svg>
  ),
  people: (
    <svg viewBox="0 0 24 24" {...P}><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
  ),
  calendar: (
    <svg viewBox="0 0 24 24" {...P}><path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5" /><path d="M16 2v4" /><path d="M8 2v4" /><path d="M3 10h5" /><path d="M17.5 17.5 16 16.3V14" /><circle cx="16" cy="16" r="6" /></svg>
  ),
  heart: (
    <svg viewBox="0 0 24 24" {...P}><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" /><path d="M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66" /><path d="m18 15-2-2" /><path d="m15 18-2-2" /></svg>
  ),
};
const STEPS = [
  ['chat', 'Choose a topic', 'What\u2019s on your mind today?'],
  ['people', 'Find your listener', 'Connect with someone who shares your interests.'],
  ['calendar', 'Book your session', 'Start now or schedule a time that works for you.'],
  ['heart', 'Enjoy the conversation', 'Talk, laugh, share, and feel heard.'],
];

const HowItWorksSteps = ({ compact = false }) => (
  <section className={compact ? `${css.howSteps} ${css.compact}` : css.howSteps} data-home-section="how-it-works" aria-labelledby="home-how-title">
    <div className={css.howCard}>
      <h2 id="home-how-title" className={css.howTitle}>How it works</h2>
      <ol className={css.howList}>
        {STEPS.map(([icon, t, b], i) => (
          <li key={t} className={css.howStep} data-home-how-step={i + 1}>
            <span className={css.howIcon} aria-hidden="true">{icons[icon]}</span>
            <span>
              <strong className={css.howStepTitle}>{t}</strong>
              <span className={css.howStepBody}>{b}</span>
            </span>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default HowItWorksSteps;
